import styled from 'styled-components';
import tsfont from '../../../tsfont.json';
import { minWidth } from 'helpers/buildMediaQueries';
import {
  ButtonChip,
  gutterVariables,
  colorsVariables,
  fontVariables
} from '@trustedshops/tps-seo-shared-frontend-react-components';
import { TextOverflowEllipsis } from 'styles/utils/text.styles';

export const CategoryListItemLink = styled.div`
  position: relative;
  padding: 4px 24px;
  display: flex;
  align-items: baseline;
  gap: 8px;
  line-height: ${fontVariables.LINE_HEIGHT_L};
  margin-bottom: ${gutterVariables.GUTTER_PLUS_HALF};
  ${minWidth('md', `margin-bottom: ${gutterVariables.GUTTER};`)};

  ${tsfont.templateOptions.baseSelector} {
    color: ${colorsVariables.GRAY_800};
  }

  &:not(.active):hover {
    background-color: #efefef;
  }

  .categoryName {
    font-size: ${fontVariables.SIZE_TEXT_M};
    color: ${colorsVariables.GRAY_700};
    line-height: ${fontVariables.LINE_HEIGHT_L};
    margin-right: ${gutterVariables.GUTTER_HALF};
    display: inline;
    ${minWidth('md', `font-size: ${fontVariables.SIZE_TEXT};`)};
  }

  .totalCount {
    display: inline-block;
    color: ${colorsVariables.GRAY_400};
  }

  &:not(.active):hover {
    ${tsfont.templateOptions.baseSelector},
    .categoryName {
      color: ${colorsVariables.BLUE_700};
    }
  }

  &.active {
    & * {
      cursor: default;
    }
    .categoryName {
      color: ${colorsVariables.GRAY_700};
      font-weight: ${fontVariables.FONT_WEIGHT_BOLD};
    }
  }
`;

export const Category = styled.ul`
  margin: 0;
  padding: 0;
  list-style-type: none;

  li a {
    text-decoration: none;
  }
`;

export const ButtonStyledCategory = styled(ButtonChip)`
  border-color: ${colorsVariables.GRAY_050};
  background-color: ${colorsVariables.GRAY_050};
  line-height: ${fontVariables.LINE_HEIGHT_S};

  .categoryName {
    display: inline-block;
    ${TextOverflowEllipsis};
    font-weight: ${fontVariables.FONT_WEIGHT_MEDIUM};
    /* 16px left distance + 16px right distance + 16px button margin right + 24px icon size + 11px padding button left + 22px padding button right + 4px button border + 8px margin to icon */
    max-width: calc(100vw - 117px);
  }

  ${tsfont.templateOptions.baseSelector} {
    color: ${colorsVariables.BLUE_700};
  }
`;
